import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="pencil-a"
            d="M12.1480732,3.14807323 L11,2 L2,11 L2,14 L5,14 L14,5 L12.8560732,3.85607323 L4.854,11.854 C4.756,11.951 4.628,12 4.5,12 C4.372,12 4.244,11.951 4.146,11.854 C3.951,11.658 3.951,11.342 4.146,11.146 L12.1480732,3.14807323 Z M11,1 C11.256,1 11.512,1.098 11.707,1.293 L14.707,4.293 C15.098,4.683 15.098,5.317 14.707,5.707 L5.707,14.707 C5.52,14.895 5.265,15 5,15 L2,15 C1.448,15 1,14.552 1,14 L1,11 C1,10.735 1.105,10.48 1.293,10.293 L10.293,1.293 C10.488,1.098 10.744,1 11,1 Z M5,14 L2,14 L2,11 L5,14 Z"/>
    </defs>
    <g>
      <use xlinkHref="#pencil-a"/>
    </g>
  </svg>
);
